import { Affixes } from '../../types/keystoneAffixTypes';

export function hasChallengersPeril(affixIds: (null | number)[]): boolean {
  return affixIds.includes(Affixes.CHALLENGERS_PERIL);
}
